import { useMemo, useState, useEffect } from 'react';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { useNavigate } from 'react-router-dom';

import CardSupplier from '@/main/components/shared/cardSupplier/cardSupplier';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import SummaryCost from '@/main/components/shared/summaryCost/summaryCost';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import ModalAudit from '../modalAudit/modalAudit';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import ModalHistory from '../modalHistory/modalHistory';
import ModalContacts from '@main/components/shared/modalContacts/modalContacts';
import ModalImages from '@/main/components/shared/modalImages/modalImages';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, Divider, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Info } from '@mui/icons-material';

import {
  buildUrlQueryParams,
  getGuidScreenByRoute,
  getTranslateByKey,
  isNullUndefined,
  isShowControlByElementId
} from '@/main/services/utils';
import {
  userIsAdmin,
  userIsBodyshop,
  userIsBuyer,
  userIsSupplier
} from '@/main/services/utilsUser';
import {
  ManageStatusItemsResponse,
  ProcurementHeaderViewOrderResponse,
  ProcurementSupplierItem,
  ProcurementViewOrderMainResponse,
  QuoteDataResponse,
  SuppliersToEvaluateResponse
} from '@/main/models/response';
import { GetItemsBySupplierRequest } from '@/main/models/request';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { useUserReducer } from '@/main/store/user';

import { IHandleSetInfo } from '../cardGrid/cardGrid';

import * as S from './styles';
import ModalPartDetails from '../../../createorder/steps/stepTwo/modalPartDetails/modalPartDetails';
import { IDetailSupplier } from '../../../createorder/steps/stepTwo/stepTwoScreen';
import { Guid } from 'guid-typescript';
import { Controls } from '@/main/services/constants/constantsControl';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import ModalEditPart from '../modalEditPart/modalEditPart';
import colors from '@/main/style/colors';
import ModalCancelReturn from '../modalCancelReturn/modalCancelReturn';
import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import ControleModalInvoice from '../controleModalInvoice/controleModalInvoice';
import { OrderStatusEnum } from '@/main/services/enum/OrderStatusEnum';
import { isReturnablePart } from './utilsInfoOrder';
import KOGOrderPrintPDF from '@/main/components/shared/KogPrintPDF/layoutsPrint/orderPrint/orderPrint';
import CopyToClipboardText from '@/main/components/shared/copyToClipboardText/copyToClipboardText';
import ModalRequoteOrderedPart from '../modalRequoteOrderedPart/modalRequoteOrderedPart';
import ModalReassignBodyshop from '../modalReassignBodyshop/modalReassignBodyshop';
import WhatsappLink from '@/main/components/shared/whatsappLink/whatsappLink';
import ModalEvaluationSupplierAlert from '../modalEvaluationSupplier/modalEvaluationSupplierAlert';
import ModalEvaluationSupplier from '../modalEvaluationSupplier/modalEvaluationSupplier';
import ModalViewEvaluationSupplier from '../modalEvaluationSupplier/modalViewEvaluationSupplier';
import {
  EvaluationCompanyBuyerResponse,
  SupplierEvaluationSaved
} from '@/main/models/response/evaluationSupplierResponse';
import {
  claimApi,
  evaluationCompanyBuyerApi,
  procurementApi,
  procurementReportApi
} from '@/main/api';
import { downloadFile } from '@/main/services/utilsFile';
import { SpinnerLoading, TextEllipsis } from '@/main/components/shared/styles';
import {
  IInfoConfirmProcess,
  IInfoReasonComponent,
  IInfoSideComponent
} from './typesInfoOrder';
import { ModalEnum } from '@/main/services/enum/ModalEnum';
import ChangeOrderStatusModal from '../changeOrderStatusModal/changeOrderStatusModal';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import ModalReason from '../modalReason/modalReason';
import ModalConfirmProcess from '../modalConfirmProcess/modalConfirmProcess';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { DefaultValueParameterEnum } from '@/main/services/enum/DefaultValueParameterEnum';
import { onLoadDateRangePicker } from '@/main/services/utilsDate';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import TotalLossComponent from '@/main/components/shared/totalLossComponent/totalLossComponent';
import useAsyncModalConfirm from '@/main/components/shared/asyncModalConfirm/asyncModalConfirm';
import { toast } from 'react-toastify';

interface IInfoOrderProps {
  guidCompany: string;
  bodyshopCompanyGuid: string;
  guidQuote: string;
  handleOpenModalTrancking: (
    { guidQuoteProcurement }: GetItemsBySupplierRequest,
    orderNumber?: string
  ) => void;
  idStatusQuote: number;
  orderNumber: string;
  claimNumber?: string;
  insurerCompanyName?: string;
  bodyShopCompanyName: string;
  rowGrid: QuoteDataResponse;
  handleUpdateQuoteCountStatus: () => void;
  handleUpdateQuoteGridStatus: (
    guid: string,
    newStatus: number,
    newStatusSupplierName: string
  ) => void;
  setResultDataManageStatus: (data: ManageStatusItemsResponse | null) => void;
  callApiGetSuppliersToEvaluate?: boolean;
  resultDataManageStatus: ManageStatusItemsResponse | null;
  refreshGrid?: () => void;

  guidClaim: string;
}

const isInvoiced = (status: number) =>
  status === ProcurementStatusEnum.Invoiced ||
  status === ProcurementStatusEnum.Paid;

const isAssigned = (status: number) =>
  status === ProcurementStatusEnum.Assigned;

const isReassigned = (item: ProcurementSupplierItem) =>
  item.idStatusPart === ProcurementStatusEnum.Assigned ||
  (item.idStatusPart === ProcurementStatusEnum.Transit &&
    !item.cancelationPending) ||
  (item.idStatusPart === ProcurementStatusEnum.Delivered && userIsAdmin()) ||
  (item.idStatusPart === ProcurementStatusEnum.Received && userIsAdmin()) ||
  (item.idStatusPart === ProcurementStatusEnum.Invoiced && userIsAdmin()) ||
  (item.idStatusPart === ProcurementStatusEnum.Paid && userIsAdmin());

const isAwaitingPayment = (status: number) =>
  status === ProcurementStatusEnum.AwaitingPayment;

const INITIAL_STATE_EDIT_PART = {
  isOpen: false as boolean,
  guidQuoteProcurement: null as string | null,
  guidProcurementSupplierItem: null as string | null
};
export type InitialStateEditPart = typeof INITIAL_STATE_EDIT_PART;

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaper-root': {
      backgroundColor: colors.white
    }
  }
}));

const useStylesTooltip = makeStyles({
  popperCustom: { marginLeft: 15 }
});

function InfoOrder({
  guidCompany,
  bodyshopCompanyGuid,
  guidQuote,
  handleOpenModalTrancking,
  idStatusQuote,
  orderNumber,
  claimNumber,
  insurerCompanyName,
  bodyShopCompanyName,
  rowGrid,
  resultDataManageStatus,
  handleUpdateQuoteCountStatus,
  handleUpdateQuoteGridStatus,
  setResultDataManageStatus,
  refreshGrid = () => {},
  guidClaim
}: IInfoOrderProps) {
  const navigate = useNavigate();
  const classesTooltip = useStylesTooltip();
  const guidQuoteProcurement = String(rowGrid.guidQuoteProcurement);
  const { currentUser: userReducer } = useUserReducer();
  const [editPart, setEditPart] = useState<InitialStateEditPart>(
    INITIAL_STATE_EDIT_PART
  );
  const [isOpenModalInvoiceQuote, setIsOpenModalInvoiceQuote] =
    useState<boolean>(false);
  const [isOpenModalAudit, setIsOpenModalAudit] = useState<boolean>(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState<boolean>(false);
  const [isOpenModalCancelReturn, setIsOpenModalCancelReturn] =
    useState<boolean>(false);
  const [isOpenModalRequote, setIsOpenModalRequote] = useState<boolean>(false);
  const [isOpenModalReassignBodyshop, setIsOpenModalReassignBodyshop] =
    useState<boolean>(false);
  // States for Evaluation supplier

  // Boolean
  const [isOpenModalEvaluationSupplier, setIsOpenModalEvaluationSupplier] =
    useState<boolean>(false);
  const [
    isOpenModalEvaluationSupplierAlert,
    setIsOpenModalEvaluationSupplierAlert
  ] = useState<boolean>(false);
  const [
    isOpenModalViewEvaluationSupplier,
    setIsOpenModalViewEvaluationSupplier
  ] = useState<boolean>(false);

  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean>(false);

  // Data
  const [suppliersToEvaluate, setSuppliersToEvaluate] = useState<
    SuppliersToEvaluateResponse[]
  >([]);
  const [suppliersEvaluationSaved, setSuppliersEvaluationSaved] = useState<
    SupplierEvaluationSaved[]
  >([]);
  const [viewEvaluationSupplier, setViewEvaluationSupplier] =
    useState<EvaluationCompanyBuyerResponse | null>(null);

  const [isModalCancel, setIsModalCancel] = useState<boolean>(false);
  const [isModalReturn, setIsModalReturn] = useState<boolean>(false);
  const [showContactModal, setShowContactModal] = useState<boolean>(false);
  const [openModalImages, setOpenModalImages] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dataHeader, setDataHeader] =
    useState<ProcurementHeaderViewOrderResponse | null>(null);
  const [dataOrder, setDataOrder] =
    useState<ProcurementViewOrderMainResponse | null>(null);
  const [isLoadingOrder, setIsLoadingOrder] = useState<boolean>(false);
  const [isLoadingHeader, setIsLoadingHeader] = useState(false);
  const [totalLossRefreshKey, setTotalLossRefreshKey] = useState<number>(0);

  const [modalTitle, setModalTitle] = useState<string>('');
  const [openModalReason, setOpenModalReason] = useState<boolean>(false);
  const [openModalConfirmProcess, setOpenModalConfirmProcess] =
    useState<boolean>(false);

  const [callApiGetSuppliersToEvaluate, setCallApiGetSuppliersToEvaluate] =
    useState<boolean>(false);

  const [getConfirmationSendUpdates, ModalConfirmationSendUpdates] =
    useAsyncModalConfirm();

  const INITIAL_INFO_SIDE = {
    guidQuoteProcurement: null,
    deliveryBySupplier: false,
    guidSupplier: null,
    statusSupplier: null,
    guidProcurementSupplier: null,
    guidProcurementStatusCompany: null,
    idProcurementStatusCompany: null,
    open: false
  };
  const INITIAL_INFO_REASON = {
    guidSupplierItem: null,
    deliveryBySupplier: false,
    idReasonType: null,
    titleModal: null,
    open: false,
    guidProcurement: null,
    guidProcurementSupplier: null,
    idProcurementStatusCompany: null
  };
  const INITIAL_INFO_CONFIRM_PROCESS = {
    guidSupplierItem: null,
    idReasonType: null,
    open: false,
    guidProcurement: null,
    guidProcurementSupplier: null,
    idProcurementStatusCompany: null,
    guidReason: ''
  };
  const [infoSideComponent, setInfoSideComponent] =
    useState<IInfoSideComponent>(INITIAL_INFO_SIDE);
  const [infoReasonComponent, setInfoReasonComponent] =
    useState<IInfoReasonComponent>(INITIAL_INFO_REASON);
  const [infoConfirmProcess, setInfoConfirmProcess] =
    useState<IInfoConfirmProcess>(INITIAL_INFO_CONFIRM_PROCESS);

  //#region Show buttons 3 dots

  const isBuyer = userIsBuyer(guidCompany);
  const isAdmin = userIsAdmin();

    const havePartTransitCancelationPending = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.some(supplier =>
            supplier.procurementSupplierItems.some(
              item =>
                  item.idStatusPart === OrderStatusEnum.Transit &&
                  item.cancelationPending
            )
          )
        : false,
    [dataOrder, dataHeader]
  );

  const showPrices = isShowControlByElementId(Controls.IdShowPrices);
  const showOrderPrint = isShowControlByElementId(Controls.IdShowOrderPrint);
  const showRequoteOrdered =
    isShowControlByElementId(Controls.IdRequoteOrdered) &&
    !dataHeader?.isStripePayment &&
    idStatusQuote !== ProcurementStatusEnum.Transferred &&
    idStatusQuote !== ProcurementStatusEnum.Cancelled &&
    idStatusQuote !== ProcurementStatusEnum.ReturnProcess &&
    idStatusQuote !== ProcurementStatusEnum.Returned &&
    idStatusQuote !== ProcurementStatusEnum.CancelProcess &&
    !havePartTransitCancelationPending &&
    (userIsAdmin || userIsBuyer);
  const showReassignBodyshop =
    isShowControlByElementId(Controls.IdReassignToBodyshop) &&
    dataHeader?.showReassigToBodyshop &&
    !dataHeader.isStripePayment;
  const haveCancelablePart = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.some(supplier =>
            supplier.procurementSupplierItems.some(
              item =>
                isShowControlByElementId(Controls.IdCancelPart) &&
                (item.idStatusPart === OrderStatusEnum.Assigned ||
                  item.idStatusPart === OrderStatusEnum.Transit) &&
                !item.cancelationPending &&
                !dataHeader?.isStripePayment
            )
          )
        : false,
    [dataOrder, dataHeader]
  );

  const showReassign =
    isShowControlByElementId(Controls.IdReassignPart) &&
    !dataHeader?.isStripePayment;
  const showPaymentURL =
    dataHeader?.isStripePayment &&
    !isNullUndefined(dataHeader?.paymentURL) &&
    (userIsAdmin || userIsBuyer);

  const modalTitleReducer =
    infoSideComponent.statusSupplier === OrderStatusEnum.Invoiced
      ? ModalEnum.InvoiceManagement
      : ModalEnum.ModalChangeStatusItem;

  const isBodyShop = userReducer?.idCompanyType === CompanyTypeEnum.BodyShop;
  const isVisibleForBodyShopRule = !(!isBuyer && isBodyShop);

  //#endregion

  const classes = useStyles();

  const guidsProcurementSupplierItem = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.flatMap(each =>
            each.procurementSupplierItems.map(item => item.guidSupplierItem)
          )
        : [],
    [dataOrder]
  );
  const haveInvoicedOrder = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.some(each =>
            each.procurementSupplierItems.some(item =>
              isInvoiced(item.idStatusPart)
            )
          )
        : false,
    [dataOrder]
  );
  const haveReturnablePart = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.some(each =>
            each.procurementSupplierItems.some(item =>
              isReturnablePart({
                guidCompany,
                idCompanyStatus: item.idStatusPart,
                bodyshopResponseTime: item.bodyshopResponseTime
              })
            )
          )
        : false,
    [dataOrder]
  );
  const showReassignPart = useMemo(
    () =>
      dataOrder
        ? dataOrder.procurementSupplier.some(each =>
            each.procurementSupplierItems.some(item => isReassigned(item))
          )
        : false,
    [dataOrder]
  );

  const showEvaluateSupplierSearchOrders = isShowControlByElementId(
    Controls.IdEvaluateSupplierSearchOrders
  );

  const [openModalDetails, setOpenModalDetails] = useState<boolean>(false);
  const [openModalImagesReturn, setOpenModalImagesReturn] =
    useState<boolean>(false);
  const [detailsModalImagesReturn, setDetailsModalImagesReturn] =
    useState<string>('');
  const INITIAL_DETAIL_SUPPLIER = {
    guid: null,
    supplierInventoryGuid: false
  };
  const [detailSupplier, setDetailSupplier] = useState<IDetailSupplier>(
    INITIAL_DETAIL_SUPPLIER
  );

  async function loadViewOrderHeader(guidQuoteProcurement: string | undefined) {
    try {
      setIsLoadingHeader(true);
      const {
        data: { result }
      } = await procurementApi.getHeaderViewOrder({
        guidQuoteProcurement: String(guidQuoteProcurement)
      });
      setDataHeader(result);
      if (
        !isNullUndefined(result) &&
        (isNullUndefined(result.ignoreSupplierEvaluation) ||
          !result.ignoreSupplierEvaluation)
      ) {
        setCallApiGetSuppliersToEvaluate(true);
      }
    } catch (error) {
    } finally {
      setIsLoadingHeader(false);
    }
  }
  async function loadViewOrder(guidQuoteProcurement: string | undefined) {
    try {
      setIsLoadingOrder(true);
      const {
        data: { result }
      } = await procurementApi.getViewOrder({
        guidScreen: getGuidScreenByRoute(RoutesConstants.orderSearchOrder),
        guidQuoteProcurement: String(guidQuoteProcurement)
      });
      setDataOrder(result);
      setTotalLossRefreshKey(prev => prev + 1);
    } catch (error) {
    } finally {
      setIsLoadingOrder(false);
    }
  }
  function viewEvaluationSupplierApi(guidEvaluationCompanyBuyerValue: string) {
    evaluationCompanyBuyerApi
      .getSupplierEvaluationByGuid(guidEvaluationCompanyBuyerValue)
      .then(response => {
        if (!isNullUndefined(response.data.result)) {
          setIsOpenModalViewEvaluationSupplier(true);
          setViewEvaluationSupplier(response.data.result);
        }
      });
  }

  function shouldOpenModalForEvaluate() {
    if ((isBuyer || isAdmin) && showEvaluateSupplierSearchOrders) {
      return true;
    }

    return false;
  }

  function evaluateSupplierApi(guidSupplier: string, supplierName: string) {
    setSuppliersToEvaluate([
      {
        guidSupplier,
        supplierName
      }
    ]);
    setIsOpenModalEvaluationSupplier(true);
  }

  function handleModalInvoiceQuote() {
    setIsOpenModalInvoiceQuote(prev => !prev);
    setAnchorEl(null);
  }
  function handleModalHistory() {
    setIsOpenModalHistory(prev => !prev);
  }

  function handleModalAudit() {
    setAnchorEl(null);
    setIsOpenModalAudit(prev => !prev);
  }
  function handleModalCancelReturn() {
    setIsOpenModalCancelReturn(prev => !prev);
  }

  function handleShowContactModal(open: boolean) {
    setShowContactModal(open);
  }

  function openPaymentDetails(paymentLink: string) {
    window.open(paymentLink);
  }
  function handleClickSeeOrderByClaim() {
    const { firstDateResult, secondDateResult } = onLoadDateRangePicker(
      DefaultValueParameterEnum.FallbackRangeDate
    );
    const urlRedirect = `${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}&startDate=${firstDateResult}&finalDate=${secondDateResult}`;
    navigate(urlRedirect);
  }

  async function handleClickSendUpdates() {
    const confirmed = await getConfirmationSendUpdates(
      getTranslateByKey('information.confirmSendUpdates')
    );
    if (!confirmed) return;

    setAnchorEl(null);

    claimApi
      .addSendUpdateQueue({ guidClaim, guidProcurement: guidQuoteProcurement })
      .then(res => {
        if (res.data) {
          toast.success(
            getTranslateByKey(
              'procurementHistoricalAction.SendUpdatesManuallyQueued'
            )
          );
        }
      });
  }

  const totalShippingCost = dataOrder?.totalShippingCost || 0;
  const totalCost = dataOrder?.totalPrice || 0;

  const hasUserPermissionInvoice =
    userReducer?.guidCompany === guidCompany ||
    userIsBodyshop() ||
    userIsSupplier() ||
    userIsAdmin();
  const showButtonInvoice = haveInvoicedOrder && hasUserPermissionInvoice;
  const showExportOrder = isShowControlByElementId(
    Controls.IdExportOrderViewOrder
  );
  const showSeeOrderByClaim =
    !isNullUndefined(dataHeader) && dataHeader.hasOrderByClaim;

  const showSendUpdates = isShowControlByElementId(
    Controls.IdSendUpdatesViewOrder
  );

  function displayPartsDetails(
    supplierInventoryGuid: string,
    guidQuoteSupplierItem: string
  ) {
    setOpenModalDetails(true);
    const request: IDetailSupplier = {
      guid:
        supplierInventoryGuid && supplierInventoryGuid !== Guid.EMPTY
          ? supplierInventoryGuid
          : guidQuoteSupplierItem,
      supplierInventoryGuid:
        supplierInventoryGuid && supplierInventoryGuid !== Guid.EMPTY
          ? false
          : true
    };
    setDetailSupplier(request);
  }

  function displayImagesReturnModal(guidProcurementSupplierItem: string) {
    setOpenModalImagesReturn(true);
    setDetailsModalImagesReturn(guidProcurementSupplierItem);
  }

  function canSeeAuditButton(): boolean {
    if (
      userIsBodyshop() &&
      dataHeader?.idBuyerCompanyType == CompanyTypeEnum.Insurer
    )
      return false;
    return isShowControlByElementId(Controls.IdShowAudit);
  }

  function canSeeBodyshopContactButton(): boolean {
    return !userIsBodyshop();
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleReassignPart() {
    const routeReassignOrder = buildUrlQueryParams(
      RoutesConstants.orderReassignOrderBulk,
      {
        guidQuoteProcurement
      }
    );
    navigate(routeReassignOrder);
  }
  function handleExportExcel() {
    if (isLoadingExcel) return;
    setIsLoadingExcel(true);
    procurementReportApi
      .exportOrderScreenReport({
        guidProcurement: guidQuoteProcurement
      })
      .then(response => {
        const {
          data: { result }
        } = response;
        const nameFile = `${orderNumber}${
          isNullUndefined(rowGrid.code) ? '' : `_${rowGrid.code}`
        }.xlsx`;
        downloadFile(result, nameFile);
      })
      .finally(() => {
        setIsLoadingExcel(false);
      });
  }
  function handleOpenInfoSide(
    guidSupplier: string,
    deliveryBySupplier: boolean,
    statusSupplier: number | null,
    open: boolean,
    guidProcurementSupplier: string,
    guidProcurementStatusCompany: string,
    idProcurementStatusCompany: number
  ) {
    const infoSide = {
      guidQuoteProcurement: rowGrid.guidQuoteProcurement,
      guidSupplier,
      deliveryBySupplier,
      statusSupplier,
      guidProcurementSupplier,
      guidProcurementStatusCompany,
      idProcurementStatusCompany,
      open
    };
    setInfoSideComponent(infoSide);
  }

  function handleSetInfoReason(propReason: IHandleSetInfo) {
    setOpenModalReason(propReason.open);
    let titleByReason: string | null;
    switch (propReason.idReasonType) {
      case ReasonTypeEnum.Cancel:
        titleByReason = getTranslateByKey('information.cancelPart');
        break;
      case ReasonTypeEnum.Part:
        titleByReason = propReason.isBuyer
          ? getTranslateByKey('information.returnPart')
          : getTranslateByKey('information.returnApprovalConfirm');
        break;
      default:
        titleByReason = null;
        break;
    }
    const infoReason = {
      ...propReason,
      titleModal: titleByReason
    };
    setInfoReasonComponent(prev => ({ ...prev, ...infoReason }));
  }

  function handleOpenConfirmProcess(propConfirmProcess: IHandleSetInfo) {
    setOpenModalConfirmProcess(propConfirmProcess.open);
    setInfoConfirmProcess(prev => ({ ...prev, ...propConfirmProcess }));
  }

  function closeModal() {
    setIsOpenModalAudit(false);
  }

  useEffect(() => {
    if (
      !isNullUndefined(dataHeader) &&
      !isNullUndefined(dataHeader.guid) &&
      !isNullUndefined(callApiGetSuppliersToEvaluate) &&
      callApiGetSuppliersToEvaluate &&
      shouldOpenModalForEvaluate()
    ) {
      procurementApi
        .getSuppliersToEvaluate({
          guidProcurement: dataHeader.guid,
          guidSupplier: Guid.EMPTY
        })
        .then(response => {
          if (
            !isNullUndefined(response.data.result) &&
            response.data.result.length > 0
          ) {
            setSuppliersToEvaluate(response.data.result);
            setIsOpenModalEvaluationSupplierAlert(true);
            if (!isNullUndefined(setCallApiGetSuppliersToEvaluate)) {
              setCallApiGetSuppliersToEvaluate(false);
            }
          }
        });
    }
  }, [dataHeader, callApiGetSuppliersToEvaluate]);

  useEffect(() => {
    if (isNullUndefined(rowGrid.guidQuoteProcurement)) return;

    if (dataHeader === null) loadViewOrderHeader(rowGrid?.guidQuoteProcurement);
    if (dataOrder === null) loadViewOrder(rowGrid?.guidQuoteProcurement);
  }, [rowGrid.guidQuoteProcurement]);

  useEffect(() => {
    switch (infoSideComponent.statusSupplier) {
      case OrderStatusEnum.Transit:
        setModalTitle(getTranslateByKey('information.sendTheParts'));
        break;

      case OrderStatusEnum.Delivered:
        setModalTitle(getTranslateByKey('information.deliveryTheParts'));
        break;

      case OrderStatusEnum.Received:
        setModalTitle(getTranslateByKey('information.receiveTheParts'));
        break;

      case OrderStatusEnum.Invoiced:
        setModalTitle(getTranslateByKey('information.invoiceManagement'));
        break;

      case OrderStatusEnum.Paid:
        setModalTitle(getTranslateByKey('information.payTheParts'));
        break;

      default:
        break;
    }
  }, [infoSideComponent.statusSupplier]);

  useEffect(() => {
    if (
      !isNullUndefined(resultDataManageStatus) &&
      !isNullUndefined(resultDataManageStatus.shouldRenderPrint) &&
      !isNullUndefined(dataHeader)
    ) {
      setDataHeader({
        ...dataHeader,
        shouldDisplayPrint: resultDataManageStatus.shouldRenderPrint
      });
    }
  }, [resultDataManageStatus]);

  const showReassignButton =
    showReassign &&
    dataHeader?.showReassigAll &&
    idStatusQuote !== ProcurementStatusEnum.Transferred;
  const isAllDeliveryBySupplier =
    !isNullUndefined(dataOrder) &&
    dataOrder.procurementSupplier.every(
      item => item.deliveryBySupplier === true
    );
  const showTrackingButton =
    idStatusQuote !== ProcurementStatusEnum.AwaitingPayment &&
    !isAllDeliveryBySupplier;
  const showTotalLoss = !userIsSupplier();

  return (
    <S.Container>
      <S.Header>
        {isLoadingHeader ? (
          <LoadingComponent />
        ) : (
          <>
            <S.AreaGrid>
              <S.GridCss id="grid-info-order" columns={2}>
                <ColumnLabel
                  label={getTranslateByKey('information.deliveryDateUntil')}
                  content={
                    <span translate="no">
                      {dataHeader?.deliveryDateFormated}
                    </span>
                  }
                />
                <ColumnLabel
                  label={getTranslateByKey('information.vin')}
                  content={
                    <CopyToClipboardText
                      maxWidth="190px"
                      label={getTranslateByKey('information.vin')}
                      valueToCopy={dataHeader?.vin ? dataHeader.vin : ''}>
                      <TextEllipsis>{dataHeader?.vin}</TextEllipsis>
                    </CopyToClipboardText>
                  }
                />
                {showTotalLoss && (
                  <TotalLossComponent
                    type="column"
                    idStatus={rowGrid.idStatus}
                    guidQuote={guidQuote}
                    refreshKey={totalLossRefreshKey}
                  />
                )}
                {isShowControlByElementId(
                  Controls.IdViewVehicleInFloorData
                ) && (
                  <ColumnLabel
                    label={getTranslateByKey('information.Infloor')}
                    content={dataHeader?.inFloor}
                  />
                )}
              </S.GridCss>

              <S.GridCss id="grid-info-bodyshop" columns={3}>
                <ColumnLabel
                  label={getTranslateByKey('information.bodyshop')}
                  content={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {canSeeBodyshopContactButton() && (
                        <>
                          <TooltipComponent
                            title={getTranslateByKey(
                              'information.viewContacts'
                            )}
                            placement="top"
                            stylePopper={classesTooltip.popperCustom}>
                            <span>
                              <IconButton
                                size="medium"
                                color="primary"
                                style={{ marginRight: 5 }}
                                onClick={() => handleShowContactModal(true)}
                                id="id-contactModal-btn-seeContactModal-order">
                                <Info />
                              </IconButton>
                            </span>
                          </TooltipComponent>
                          <ModalContacts
                            guidCompany={bodyshopCompanyGuid}
                            infoProcurement={{
                              claimNumber: String(rowGrid?.claimNumber),
                              insurerName: rowGrid?.insurerCompanyName,
                              companyName: bodyShopCompanyName,
                              orderNumber: rowGrid?.orderNumber,
                              vehicleName: rowGrid?.vehicle
                            }}
                            closeModal={() => handleShowContactModal(false)}
                            open={showContactModal}
                          />
                        </>
                      )}
                      <TextEllipsis>{bodyShopCompanyName}</TextEllipsis>
                    </div>
                  }
                />

                <ColumnLabel
                  idContainer="collumn-deliveryAddres"
                  label={getTranslateByKey('information.deliveryAddress')}
                  content={dataHeader?.deliveryAddress}
                />

                <ColumnLabel
                  label={getTranslateByKey('information.contactName')}
                  content={dataHeader?.contactName}
                />
                <ColumnLabel
                  label={getTranslateByKey('information.contactPhoneBodyshop')}
                  content={
                    <WhatsappLink
                      phone={String(dataHeader?.contactPhone)}
                      isWhatsapp={dataHeader?.contactNumberIsWhatsapp}
                      claimNumber={claimNumber ?? ''}
                      companyName={rowGrid.bodyShopCompanyName}
                      orderNumber={orderNumber}
                      vehicleName={rowGrid.vehicle}
                      insurerName={insurerCompanyName}
                    />
                  }
                />
                <ColumnLabel
                  label={getTranslateByKey('information.contactEmail')}
                  content={
                    <div style={{ display: 'flex' }}>
                      <TextEllipsis>{dataHeader?.contactEmail}</TextEllipsis>
                    </div>
                  }
                />
              </S.GridCss>
            </S.AreaGrid>

            <S.AreaButton>
              <TooltipComponent
                title={`${getTranslateByKey(
                  'information.clickToSeeTheActions'
                )}`}
                placement="top"
                stylePopper={classesTooltip.popperCustom}>
                <S.ButtonTrigger type="button" onClick={handleClick}>
                  <MoreVertIcon
                    className="ignore-click"
                    id="id-infoOrder-icon-threeDots"
                  />
                </S.ButtonTrigger>
              </TooltipComponent>
              {anchorEl !== null && (
                <Menu
                  anchorEl={anchorEl}
                  open={isOpenModalCancelReturn ? false : Boolean(anchorEl)}
                  onClose={handleClose}
                  elevation={2}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button'
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  className={classes.root}
                  style={{ zIndex: 1 }}>
                  <MenuItem
                    id="id-infoOrder-handleModalHistory-Order"
                    onClick={() => {
                      (setAnchorEl(null), handleModalHistory());
                    }}>
                    <Divider />
                    {getTranslateByKey('information.history')}
                  </MenuItem>
                  {canSeeAuditButton() && (
                    <MenuItem
                      id="id-infoOrder-informationAudit-Order"
                      onClick={handleModalAudit}>
                      {getTranslateByKey('information.audit')}
                      <Divider />
                    </MenuItem>
                  )}
                  <MenuItem
                    id="id-infoOrder-ModalImages-Order"
                    onClick={() => {
                      (setAnchorEl(null), setOpenModalImages(true));
                    }}>
                    {getTranslateByKey('information.images')} /{' '}
                    {getTranslateByKey('information.files')}
                  </MenuItem>
                  {showTrackingButton && (
                    <MenuItem
                      id="id-infoOrder-handleOpenModalTrancking-Order"
                      onClick={() => {
                        (handleOpenModalTrancking(
                          {
                            guidQuoteProcurement
                          },
                          orderNumber
                        ),
                          setAnchorEl(null));
                      }}>
                      <Divider />
                      {getTranslateByKey('information.tracking')}
                    </MenuItem>
                  )}
                  {showButtonInvoice && (
                    <MenuItem
                      id="id-infoOrder-handleModalInvoiceQuote-Order"
                      onClick={handleModalInvoiceQuote}>
                      <Divider />
                      {getTranslateByKey('information.invoices')}
                    </MenuItem>
                  )}
                  {haveCancelablePart && isVisibleForBodyShopRule && (
                    <MenuItem
                      id="id-infoOrder-CancelReturn-Order"
                      onClick={() => {
                        (setIsOpenModalCancelReturn(true),
                          setAnchorEl(null),
                          setIsModalCancel(true),
                          setIsModalReturn(false));
                      }}>
                      <Divider />
                      {getTranslateByKey('information.cancel')}
                    </MenuItem>
                  )}
                  {isShowControlByElementId(Controls.IdBtnReturn) &&
                    haveReturnablePart && (
                      <MenuItem
                        id="id-infoOrder-informationReturn-Order"
                        onClick={() => {
                          (setIsOpenModalCancelReturn(true),
                            setAnchorEl(null),
                            setIsModalCancel(false),
                            setIsModalReturn(true));
                        }}>
                        <Divider />
                        {getTranslateByKey('information.return')}
                      </MenuItem>
                    )}
                  {showReassignButton && isVisibleForBodyShopRule && (
                    <MenuItem
                      id="id-infoOrder-ReassignPart-Order"
                      onClick={handleReassignPart}>
                      <Divider />
                      {getTranslateByKey('information.reassign')}
                    </MenuItem>
                  )}
                  {showOrderPrint && dataHeader?.shouldDisplayPrint && (
                    <MenuItem id="id-infoOrder-informationPrint=Order">
                      <Divider />
                      <KOGOrderPrintPDF
                        fileName={`${orderNumber}${
                          isNullUndefined(claimNumber) ? '' : `_${claimNumber}`
                        }`}
                        guidProcurement={guidQuoteProcurement}
                        showPrices={showPrices}
                        labelTrigger={getTranslateByKey('information.print')}
                        printPrice={true}
                      />
                    </MenuItem>
                  )}
                  {showOrderPrint && (
                    <MenuItem id="id-infoOrder-informationPrintNoPrice-Order">
                      <Divider />
                      <KOGOrderPrintPDF
                        fileName={`${orderNumber}${
                          isNullUndefined(claimNumber) ? '' : `_${claimNumber}`
                        }`}
                        guidProcurement={guidQuoteProcurement}
                        showPrices={false}
                        labelTrigger={getTranslateByKey(
                          'information.printNoPrice'
                        )}
                        printPrice={false}
                      />
                    </MenuItem>
                  )}
                  {showRequoteOrdered && isVisibleForBodyShopRule && (
                    <MenuItem
                      id="id-infoOrder-informationRequote-Order"
                      onClick={() => {
                        setAnchorEl(null);
                        setIsOpenModalRequote(true);
                      }}>
                      <Divider />
                      {getTranslateByKey('information.requote')}
                    </MenuItem>
                  )}
                  {showReassignBodyshop && isVisibleForBodyShopRule && (
                    <MenuItem
                      id="id-infoOrder-information.reassignToBodyshop-Order"
                      onClick={() => {
                        setAnchorEl(null);
                        setIsOpenModalReassignBodyshop(true);
                      }}>
                      <Divider />
                      {getTranslateByKey('information.reassignToBodyshop')}
                    </MenuItem>
                  )}
                  {showExportOrder && (
                    <MenuItem onClick={() => handleExportExcel()}>
                      <Divider />
                      {getTranslateByKey('information.exportExcel')}{' '}
                      {isLoadingExcel && <SpinnerLoading size="xsmall" />}
                    </MenuItem>
                  )}
                  {showPaymentURL && isAwaitingPayment(idStatusQuote) && (
                    <MenuItem
                      onClick={() => {
                        openPaymentDetails(dataHeader?.paymentURL);
                      }}>
                      {getTranslateByKey('information.paymentDetails')}
                    </MenuItem>
                  )}
                  {showSeeOrderByClaim && (
                    <MenuItem
                      onClick={() => {
                        handleClickSeeOrderByClaim();
                      }}>
                      {getTranslateByKey('information.seeOrderByClaim')}
                    </MenuItem>
                  )}
                  {showSendUpdates && (
                    <MenuItem
                      onClick={() => {
                        handleClickSendUpdates();
                      }}>
                      {getTranslateByKey('integrationInterface.sendUpdates')}
                    </MenuItem>
                  )}
                </Menu>
              )}
            </S.AreaButton>
          </>
        )}
      </S.Header>
      <S.Content>
        {isLoadingOrder ? (
          <LoadingComponent />
        ) : (
          dataOrder?.procurementSupplier?.map((item, index) => (
            <CardSupplier
              key={index}
              showPrices={showPrices}
              dataHeader={dataHeader}
              guidSupplier={item.guidSupplier}
              guidCompany={guidCompany}
              guidCompanySupplier={item.guidCompany}
              supplierName={item.companyName}
              isFavoriteProp={item.favorite}
              deliveryBySupplier={item.deliveryBySupplier}
              supplierItems={item.procurementSupplierItems}
              shippingCost={item?.shippingCost}
              itemTotalCost={item?.totalSupplierPrice}
              handleOpenInfoSide={handleOpenInfoSide}
              guidProcurementSupplier={item.guidProcurementSupplier}
              displayPartsDetails={displayPartsDetails}
              displayImagesReturnModal={displayImagesReturnModal}
              procurementSupplierNextStatus={item.procurementSupplierNextStatus}
              handleSetInfoReason={handleSetInfoReason}
              handleOpenConfirmProcess={handleOpenConfirmProcess}
              guidQuoteProcurement={guidQuoteProcurement}
              contactName={item.contactName}
              contactEmail={item.contactEmail}
              contactPhone={item.contactPhone}
              guidQuote={guidQuote}
              rowGrid={rowGrid}
              contactNumberIsWhatsapp={item.contactPhoneIsWhatsApp}
              setEditPart={setEditPart}
              scoreSupplier={item.supplierScore}
              evaluationSupplierEnum={item.evaluationSupplierEnum}
              guidEvaluationCompanyBuyer={item.guidEvaluationCompanyBuyer}
              supplierEvaluationSaved={suppliersEvaluationSaved}
              viewEvaluationSupplierApi={viewEvaluationSupplierApi}
              evaluateSupplierApi={evaluateSupplierApi}
              handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
              handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
              setResultDataManageStatus={setResultDataManageStatus}
              loadViewOrder={loadViewOrder}
            />
          ))
        )}
      </S.Content>
      <S.Footer>
        <SummaryCost
          showPrices={showPrices}
          hideShippingCost
          shippingCost={totalShippingCost}
          total={totalCost}
          deliveryBySupplier={isAllDeliveryBySupplier}
        />
      </S.Footer>

      <KogModalSideComponent
        shouldRenderOpen
        width="min(850px, calc(100vw - 16px))"
        open={isOpenModalAudit}
        title={getTranslateByKey('information.audit')}
        closeModal={() => setIsOpenModalAudit(false)}>
        <ModalAudit
          orderNumber={orderNumber}
          quoteDateFormatted={rowGrid.quoteDateFormatted}
          guidProcurement={guidQuoteProcurement}
          handleModalAudit={handleModalAudit}
        />
        <S.FooterButtonHistory>
          <SecondaryButton
            id="id-createOrder-button-back"
            onClick={() => closeModal()}>
            {getTranslateByKey('information.back')}
          </SecondaryButton>
        </S.FooterButtonHistory>
      </KogModalSideComponent>

      <ModalImages
        isOpenModal={openModalImages}
        closeModal={() => setOpenModalImages(false)}
        setIsOpenModal={setOpenModalImages}
        canUploadImages={false}
        canShowPDF={true}
        guidQuote={guidQuote}
        guidClaim={''}
        removeDeleteButton
        canDownloadImages={useKogControlElementId(
          Controls.IdDownloadImagesSearchOrdersControl
        )}
      />

      <ControleModalInvoice
        guidsProcurementSupplierItem={guidsProcurementSupplierItem}
        handleModalInvoiceQuote={handleModalInvoiceQuote}
        isOpenModalInvoiceQuote={isOpenModalInvoiceQuote}
        setIsOpenModalInvoiceQuote={setIsOpenModalInvoiceQuote}
      />

      <KogModalSideComponent
        shouldRenderOpen
        open={editPart.isOpen}
        title={getTranslateByKey('information.edit')}
        titleModalReducer="ModalPartEdit"
        closeModal={() => setEditPart(INITIAL_STATE_EDIT_PART)}>
        <ModalEditPart
          editPart={editPart}
          closeModal={() => setEditPart(INITIAL_STATE_EDIT_PART)}
          loadViewOrder={loadViewOrder}
          INITIAL_STATE_EDIT_PART={INITIAL_STATE_EDIT_PART}
          refreshGrid={refreshGrid}
        />
      </KogModalSideComponent>

      <KogModalSideComponent
        open={openModalDetails}
        closeModal={() => {
          setOpenModalDetails(false);
          setDetailSupplier(INITIAL_DETAIL_SUPPLIER);
        }}>
        {openModalDetails && (
          <ModalPartDetails
            closeModal={() => {
              setOpenModalDetails(false);
              setDetailSupplier(INITIAL_DETAIL_SUPPLIER);
            }}
            guid={detailSupplier.guid}
            quoteSupplierItem={detailSupplier.supplierInventoryGuid}
          />
        )}
      </KogModalSideComponent>

      <KogModalSideComponent
        open={isOpenModalHistory}
        title={getTranslateByKey('information.history')}
        closeModal={() => setIsOpenModalHistory(false)}>
        {isOpenModalHistory && (
          <ModalHistory
            showPrices={showPrices}
            guidProcurement={guidQuoteProcurement}
            guidQuote={guidQuote}
            isBuyer={isBuyer}
            handleModalHistory={handleModalHistory}
          />
        )}
      </KogModalSideComponent>

      <KogModalSideComponent
        titleModalReducer={'ModalCancelReturn'}
        open={isOpenModalCancelReturn}
        title={
          isModalCancel
            ? `${getTranslateByKey('information.cancel')} ${getTranslateByKey(
                'information.order'
              ).toLowerCase()}: ${orderNumber}`
            : `${getTranslateByKey('information.return')} ${getTranslateByKey(
                'information.order'
              ).toLowerCase()}: ${orderNumber}`
        }
        closeModal={() => setIsOpenModalCancelReturn(false)}
        isClosedOtherModal={false}>
        {isOpenModalCancelReturn && (
          <ModalCancelReturn
            isModalCancel={isModalCancel}
            isModalReturn={isModalReturn}
            dataHeader={dataHeader}
            dataOrder={dataOrder?.procurementSupplier}
            guidProcurement={guidQuoteProcurement}
            handleModalCancelReturn={handleModalCancelReturn}
            handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
            handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
            loadViewOrder={() => loadViewOrder(guidQuoteProcurement)}
            setResultDataManageStatus={setResultDataManageStatus}
          />
        )}
      </KogModalSideComponent>
      <ModalRequoteOrderedPart
        orderNr={orderNumber}
        claimNr={claimNumber}
        guidQuote={guidQuote}
        guidProcurement={guidQuoteProcurement}
        isOpenModal={isOpenModalRequote}
        setIsOpenModal={setIsOpenModalRequote}
        closeModal={() => setIsOpenModalRequote(false)}
      />
      <ModalReassignBodyshop
        isOpenModal={isOpenModalReassignBodyshop}
        guidProcurement={guidQuoteProcurement}
        guidQuote={guidQuote}
        claimNumber={claimNumber}
        setIsOpenModal={setIsOpenModalReassignBodyshop}
        closeModal={() => setIsOpenModalReassignBodyshop(false)}
      />
      {/* Modal Evaluation Supplier Alert */}
      <ModalEvaluationSupplierAlert
        onConfirm={() => {
          setIsOpenModalEvaluationSupplierAlert(false);
          setIsOpenModalEvaluationSupplier(true);
        }}
        isOpenModal={isOpenModalEvaluationSupplierAlert}
        setIsOpenModal={setIsOpenModalEvaluationSupplierAlert}
        closeModal={() => setIsOpenModalEvaluationSupplierAlert(false)}
        suppliers={suppliersToEvaluate}
        guidProcurement={guidQuoteProcurement}
      />

      {/* Modal Evaluation Supplier */}
      <ModalEvaluationSupplier
        isOpenModal={isOpenModalEvaluationSupplier}
        setIsOpenModal={setIsOpenModalEvaluationSupplier}
        closeModal={() => setIsOpenModalEvaluationSupplier(false)}
        suppliers={suppliersToEvaluate}
        callbackActionAfterSaveSuccess={(
          guidSupplierParam: string,
          guidEvaluationCompanyBuyerParam: string
        ) => {
          setSuppliersEvaluationSaved([
            ...suppliersEvaluationSaved,
            {
              guidEvaluationCompanyBuyer: guidEvaluationCompanyBuyerParam,
              guidSupplier: guidSupplierParam
            }
          ]);
        }}
        guidProcurement={guidQuoteProcurement}
      />

      {/* Modal View Evaluation Supplier */}
      <ModalViewEvaluationSupplier
        isOpenModal={isOpenModalViewEvaluationSupplier}
        setIsOpenModal={setIsOpenModalViewEvaluationSupplier}
        closeModal={() => {
          setIsOpenModalViewEvaluationSupplier(false);
          setViewEvaluationSupplier(null);
        }}
        isUserSupplier={userIsSupplier()}
        data={viewEvaluationSupplier}
      />

      <KogModalSideComponent
        closeModal={() => setInfoSideComponent(INITIAL_INFO_SIDE)}
        open={infoSideComponent.open}
        title={modalTitle}
        titleModalReducer={modalTitleReducer}>
        <ChangeOrderStatusModal
          infoSideComponent={infoSideComponent}
          setInfoSideComponent={setInfoSideComponent}
          handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
          INITIAL_INFO_SIDE={INITIAL_INFO_SIDE}
          handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
          loadViewOrder={loadViewOrder}
        />
      </KogModalSideComponent>

      {infoReasonComponent.open && (
        <KogModalFadeComponent
          open={openModalReason}
          setOpen={setOpenModalReason}>
          <ModalReason
            title={infoReasonComponent.titleModal}
            idReasonType={infoReasonComponent.idReasonType}
            closeModalReason={setOpenModalReason}
            infoReasonComponent={infoReasonComponent}
            handleSaveCustom={() => loadViewOrder(rowGrid.guidQuoteProcurement)}
            handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
            handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
            setResultDataManageStatus={setResultDataManageStatus}
          />
        </KogModalFadeComponent>
      )}

      {openModalConfirmProcess && (
        <KogModalFadeComponent
          open={openModalConfirmProcess}
          setOpen={setOpenModalConfirmProcess}>
          <ModalConfirmProcess
            infoConfirmProcess={infoConfirmProcess}
            closeModalConfirm={setOpenModalConfirmProcess}
            loadViewOrder={() => loadViewOrder(rowGrid.guidQuoteProcurement)}
            handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
            handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
            setResultDataManageStatus={setResultDataManageStatus}
          />
        </KogModalFadeComponent>
      )}

      <ModalConfirmationSendUpdates />
    </S.Container>
  );
}

export default InfoOrder;
